import React from 'react'
import { InputStyle } from './style'

type InputUserProps = React.FC<{
  label: string
  onFocus?: () => void
  onBlur?: () => void
  onChange: (e: { target: HTMLInputElement }) => void
  value: string
  disabled?: boolean
  placeholder?: string
  isValidate?: boolean
}>

export const InputUser: InputUserProps = ({
  label,
  onFocus,
  onBlur,
  onChange,
  value,
  disabled,
  placeholder,
  isValidate = true
}) => {
  return (
    <InputStyle isValidate={isValidate}>
      <label>{label}</label>
      <input
        type="text"
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
      />
    </InputStyle>
  )
}
